import React, { useState } from 'react';
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Fade from '@mui/material/Fade';
import InputTextBox from './InputTextBox';
import axios from 'axios';

// モーダルのスタイル
const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  maxWidth: 500,
  bgcolor: 'background.paper',
  border: 'solid 1px',
  borderRadius: '4px',
  borderColor: '#1976D2',
  boxShadow: 24,
  pt: 2,
  px: 2,
  pb: 3,
};

// 検索結果ボックスのスタイル
const resultBoxStyle = {
  height: 300,
  border: 'solid 1px',
  borderRadius: '8px',
  borderColor: '#5c5c5c',
  overflowY: 'scroll',
  padding: 1
};


// 支店名選択ダイアログ
function SearchBranchModal(props) {
  const [searchWord, setSearchWord] = useState('');
  const [searchResultList, setSearchResultList] = useState([]);
  const [isSearched, setIsSearched] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const isSelectedBank = props.bankCode !== '';

  const handleSearchBranchName = () => {
    setSearchResultList([]);
    setIsLoading(true);
    setIsSearched(false);
    axios
      .get(process.env.REACT_APP_API_DOMAIN + '/v1/branch/?bank=' + props.bankCode + '&name=' + searchWord)
      .then(res => {
        const list = [];
        res.data.forEach(element => {
          list.push({ 'name': element.branch_name, 'id': element.branch_id });
        });
        setIsLoading(false);
        setSearchResultList(list);
        setIsSearched(true);
      })
      .catch(() => {
        setIsLoading(false);
        setIsSearched(true);
      });
  };

  const handleKeyPress = (e) => {
    if (!e.nativeEvent.isComposing && e.key === 'Enter') handleSearchBranchName();
  }

  return (
    <Box sx={{ ...modalStyle }}>
      <Grid container spacing={3} alignItems='center' justifyContent='center'>
        <Grid item xs={12}>
          <InputTextBox
            id='branchName'
            label='支店名を検索後、選択してください。'
            placeholder='あざみ野'
            value={searchWord}
            onChange={setSearchWord}
            onKeyUp={handleKeyPress}
            isUseNecessity={false}
          />
        </Grid>

        <Grid item xs={6}>
          <p style={{ fontSize: 12 }}>ゆうちょ銀行の場合、店番を漢字で入力してください。</p>
          <p style={{ fontSize: 12 }}>例）019 → 〇一九</p>
        </Grid>
        <Grid item xs={3}>
          <Button
            variant='contained'
            onClick={() => handleSearchBranchName()}
            disabled={isLoading}
            fullWidth
          >
            検索
          </Button>
        </Grid>
        <Grid item xs={3}>
          <Button
            variant='text'
            onClick={() => props.onClose()}
            fullWidth
          >
            閉じる
          </Button>
        </Grid>

        <Grid item xs={12}>
          <Box sx={{ ...resultBoxStyle }}>
            <div style={{ display: !isSelectedBank ? 'block' : 'none' }} className='errorMessage'>
              <p>先に銀行名をご選択ください。</p>
            </div>

            <div style={{ display: searchResultList.length === 0 && isSearched && isSelectedBank ? 'block' : 'none' }} className='errorMessage'>
              <p>見つかりませんでした。</p>
              <br />
              <p>●末尾の「支店」は省略 してご入力ください</p>
              <p>●支店名に漢字 が入る場合は、漢字でご入力ください</p>
              <p>●支店名にアルファベット 等が入る場合は、全角でご入力ください</p>
              <p>＜例＞ 　PayPay 支店　→　「ＰａｙＰａｙ」</p>
            </div>

            <div>
              {searchResultList.map((item, index) => (
                <Button
                  variant='outlined'
                  onClick={() => props.onDecideBranch(item)}
                  sx={{
                    p: 1,
                    m: 1,
                    maxHeight: 42.5,
                  }}
                >
                  {item.name}
                </Button>
              ))}
            </div>
          </Box>
        </Grid>

        <Grid item xs={12} style={{ textAlign: 'center', marginTop: '-400px', pointerEvents: 'none' }}>
          <Fade in={isLoading}>
            <CircularProgress />
          </Fade>
        </Grid>
      </Grid>
    </Box>
  );
};

export default SearchBranchModal